import { render, staticRenderFns } from "./InboundQuota.vue?vue&type=template&id=23a5c482&"
import script from "./InboundQuota.vue?vue&type=script&lang=js&"
export * from "./InboundQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports